/**
 * DiscardChangesModal component
 * Modal for confirming discard of unsaved changes
 */

import ConfirmModal from "@/components/ConfirmModal";

interface DiscardChangesModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Handler for closing the modal (cancel) */
  onClose: () => void;
  /** Handler for confirming discard */
  onConfirm: () => void;
}

export function DiscardChangesModal({ isOpen, onClose, onConfirm }: DiscardChangesModalProps) {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Descartar alterações"
      message="Descartar alterações não salvas?"
      confirmText="Descartar"
      cancelText="Cancelar"
      variant="warning"
    />
  );
}
